import {FC, Fragment} from 'react';
import {Link} from 'react-router';

const Error404Page: FC = () => {
  return (
    <Fragment>
      <div className="page error-bg dark:!bg-bodybg" id="particles-js">
        <div className="error-page">
          <div className="text-defaulttextcolo dark:text-defaulttextcolor/70r container text-defaultsize">
            <div className="my-auto p-5 text-center">
              <div className="flex h-full items-center justify-center !text-defaulttextcolor">
                <div className="xl:col-span-3"></div>
                <div className="col-span-12 xl:col-span-6">
                  <p className="error-text mb-2 sm:mb-0">404</p>
                  <p className="mb-4 text-[1.125rem] font-semibold">
                    Oops 😭,The page you are looking for is not available.
                  </p>
                  <div className="mb-[3rem] flex items-center justify-center">
                    <div className="w-[50%] xl:col-span-6">
                      <p className="mb-0 opacity-[0.7]">
                        We are sorry for the inconvenience,The page you are trying to access has been removed or never
                        been existed.
                      </p>
                    </div>
                  </div>
                  <Link to={`${import.meta.env.BASE_URL}`} className="ti-btn bg-primary font-semibold text-white">
                    <i className="ri-arrow-left-line inline-block align-middle"></i>BACK TO HOME
                  </Link>
                </div>
                <div className="xl:col-span-3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Error404Page;
